<template>
	<section>
		<v-layout wrap pa-5>
			<v-flex xs12 mb-4>
				<v-select
					background-color="white"
					box
					class="body-1"
					hide-details
					:items="domains"
					item-text="name"
					item-value="domain"
					disabled
					label="Dominio"
					v-model="newService.domain"
				></v-select>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-select
					background-color="white"
					box
					class="body-1"
					hide-details
					item-text="name"
					item-value="name"
					:items="methods"
					disabled
					label="Método"
					v-model="newService.method"
				></v-select>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-text-field
					background-color="white"
					box
					class="body-1"
					hide-details
					label="URI"
					readonly
					v-model="newService.path"
				>
				</v-text-field>
			</v-flex>
			<v-flex xs12 mb-4>
				<v-text-field
					background-color="white"
					box
					class="body-1"
					hide-details
					label="Nombre"
					readonly
					v-model="newService.name"
				>
				</v-text-field>
			</v-flex>
			<v-flex>
				<v-checkbox
					color="success"
					hide-details
					label="Auth"
					v-model="newService.flagAuth"
					>
				</v-checkbox>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="false"
				@accept-button-clicked="$emit('save-edit-service', newService)"
				@cancel-button-clicked="$emit('close')"
			>
			</modal-sidebar-button>
		</section>
	</section>
</template>
<script>
function created() {
	this.newService = { ...this.service };
}

function data() {
	return {
		newService: {},
	};
}
export default {
	name: 'service-edit',
	created,
	data,
	props: {
		domains: {
			default: () => [],
			type: Array,
		},
		service: {
			default: () => {},
			type: Object,
		},
		methods: {
			default: () => [],
			type: Array,
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/resource-service/service-edit.vue